var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1799 50.47C30.4266 50.47 26.5299 48.5334 23.4499 39.27L21.7699 34.23L16.7299 32.55C7.48989 29.47 5.55322 25.5734 5.55322 22.82C5.55322 20.09 7.48989 16.17 16.7299 13.0667L36.5399 6.46338C41.4866 4.80671 45.6166 5.29671 48.1599 7.81671C50.7032 10.3367 51.1932 14.49 49.5366 19.4367L42.9332 39.2467C39.8299 48.5334 35.9332 50.47 33.1799 50.47ZM17.8266 16.4034C11.3399 18.5734 9.02989 21.14 9.02989 22.82C9.02989 24.5 11.3399 27.0667 17.8266 29.2134L23.7066 31.1734C24.2199 31.3367 24.6399 31.7567 24.8032 32.27L26.7632 38.15C28.9099 44.6367 31.4999 46.9467 33.1799 46.9467C34.8599 46.9467 37.4266 44.6367 39.5966 38.15L46.1999 18.34C47.3899 14.7467 47.1799 11.8067 45.6632 10.29C44.1466 8.77338 41.2066 8.58671 37.6366 9.77671L17.8266 16.4034Z",
    fill: "#6B6B6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5899 33.6C23.1465 33.6 22.7032 33.4366 22.3532 33.0866C21.6765 32.41 21.6765 31.29 22.3532 30.6133L30.7065 22.2366C31.3832 21.56 32.5032 21.56 33.1799 22.2366C33.8565 22.9133 33.8565 24.0333 33.1799 24.71L24.8265 33.0866C24.4999 33.4366 24.0332 33.6 23.5899 33.6Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend2);
export default __webpack_public_path__ + "static/media/send-2.4e55b466eab933c63021968f645125d4.svg";
export { ForwardRef as ReactComponent };